export default __webpack_public_path__ + "static/media/coaching_icon.39526773.png";